// Helper function to get shop currency
function getShopCurrency() {
  const currencyElement = document.getElementById('currency_iso_code');
  if (currencyElement) {
    const currency = currencyElement.textContent.trim();
    return currency;
  }

  return 'USD';
}
function convertToActiveCurrency(amountInBaseCurrency) {
  const { rate } = Shopify?.currency;
  return amountInBaseCurrency / rate;
}
function convertFreeGiftCurrency(amountInBaseCurrency) {
  const { rate } = Shopify?.currency;
  return amountInBaseCurrency * rate;
}
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace(',', '.');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.theme?.moneyFormat || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function extractCampaignDataFromFunnels() {
  if (!window.mrPreCheckoutFunnels || !Array.isArray(window.mrPreCheckoutFunnels)) {
    return { campaigns: [], productHandles: [] };
  }

  const campaigns = [];
  const productHandles = new Set();

  window.mrPreCheckoutFunnels.forEach(funnel => {
    if (funnel.is_enable) {
      extractProductHandles(funnel, productHandles);
      const campaign = createCampaignFromFunnel(funnel);
      campaigns.push(campaign);
    }
  });


  return {
    campaigns: campaigns,
    productHandles: Array.from(productHandles)
  };
}

function extractProductHandles(funnel, productHandles) {
  if (funnel.triggerType === 'cart_page' && funnel.milestones && Array.isArray(funnel.milestones)) {
    funnel.milestones.forEach(milestone => {
      if (milestone.rewards && Array.isArray(milestone.rewards)) {
        milestone.rewards.forEach(reward => {
          if (reward.rewardType === 'freegift' && reward.rewardProducts) {
            reward.rewardProducts.forEach(product => {
              productHandles.add(product.title.toLowerCase().replace(/[^a-z0-9]/g, '-'));
            });
          }
        });
      }
    });
  }

  // Handle product_page funnels with offered_products
  if (funnel.triggerType === 'product_page' && funnel.offered_products && Array.isArray(funnel.offered_products)) {
    funnel.offered_products.forEach(product => {
      productHandles.add(product.title.toLowerCase().replace(/[^a-z0-9]/g, '-'));
    });
  }
}

function createCampaignFromFunnel(funnel) {
  // Calculate maximum gifts based on funnel type
  const maxGifts = funnel.triggerType === 'product_page' ?
    (funnel.offerLevelDiscountQuantity || funnel.offered_products?.length || 1) :
    (funnel.milestoneLevelFreegiftDiscountQuantity || funnel.milestones?.[0]?.rewards?.[0]?.freeGiftAutoAddLimit || 2);


  return {
    id: `campaign-${funnel.id}`,
    name: funnel.funnel_name,
    type: funnel.funnelType,
    status: funnel.is_enable ? 'active' : 'inactive',
    displayLocation: funnel.triggerType === 'product_page' ? 'product_page' : 'cart_page',
    priority: funnel.priority || 999,
    groups: funnel.groups || [],
    offeredProducts: funnel.triggerType === 'product_page' ? funnel.offered_products?.map(product => {
      const handle = product.title.toLowerCase().replace(/[^a-z0-9]/g, '-');
      return {
        id: product.id.toString(),
        title: product.title,
        handle: handle,
        productHandle: handle,
        image: product.image || '',
        variants: product.variants.map(variant => ({
          id: variant.id,
          price: variant.price,
          title: variant.title,
          compare_at_price: variant.compareAtPrice
        }))
      };
    }) : [],
    milestones: funnel.triggerType === 'cart_page' ? {
      method: 'cart_value',
      currency: funnel?.currencyCode || 'USD',
      minimumTriggerValue: funnel.milestones?.[0]?.minValue || 100,
      milestones: funnel.milestones?.map(milestone => ({
        id: `milestone-${milestone.milestoneID}`,
        minimumValue: parseFloat(milestone.minValue),
        gifts: milestone.rewards?.filter(reward => reward.rewardType === 'freegift')
          .flatMap(reward => reward.rewardProducts?.map(product => {
            const handle = product.title.toLowerCase().replace(/[^a-z0-9]/g, '-');
            return {
              productHandle: handle,
              handle: handle,
              title: product.title,
              minimumTriggerValue: parseFloat(milestone.minValue),
              productData: product
            };
          }) || []) || []
      })) || []
    } : null,
    advancedConfig: {
      shownOnlyIfEligible: true,
      allAchievedMilestonesAwarded: true,
      keepGiftInCart: true,
      giftOptOutDisabled: true,
      hideGiftPrice: true,
      hideGiftAfterAddition: true
    },
    maximumGifts: maxGifts,
    enabledGiftLimitation: false
  };
}

// Wait for mrPreCheckoutFunnels data to be loaded
function waitForMrPreCheckoutFunnels() {
  return new Promise((resolve) => {
    const timeout = 5000; // 5 seconds
    const startTime = Date.now();
    
    const checkData = () => {
      if (window.mrPreCheckoutFunnels && Array.isArray(window.mrPreCheckoutFunnels)) {
        console.log('✅ mrPreCheckoutFunnels data is ready');
        resolve();
      } else if (Date.now() - startTime >= timeout) {
        console.log('⚠️ Timeout: mrPreCheckoutFunnels data not available after 5s');
        resolve(); // Resolve anyway để không block
      } else {
        console.log('⏳ Waiting for mrPreCheckoutFunnels data...');
        setTimeout(checkData, 100);
      }
    };
    checkData();
  });
}

document.addEventListener('DOMContentLoaded', async function () {
  const freeGiftsContainer = document.querySelector('.free-gifts');
  const giftsContainer = document.getElementById('gifts-container');
  if (!freeGiftsContainer) return;
  const currentProductHandle = freeGiftsContainer.dataset.currentProduct;
  const currentProductId = freeGiftsContainer.dataset.productId;
  async function getCurrentVariant() {
    // Try to get variant from step-footer-wrapper first
    const moneyElement = document.querySelector('.step-footer-wrapper .money[data-variant-id]');

    if (moneyElement) {
      const variantId = moneyElement.getAttribute('data-variant-id');
      const priceText = moneyElement.textContent.trim();

      // Parse price - remove currency symbols and convert to number
      const priceMatch = priceText.match(/[\d,.]+/);
      if (priceMatch && variantId) {
        const price = parseFloat(priceMatch[0].replace(/,/g, ''));

        return {
          id: variantId,
          price: price // Price is already in cents/full amount
        };
      }
    }

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    const variantId = form.querySelector('input[name="id"]')?.value ||
      form.querySelector('select[name="id"]')?.value ||
      form.querySelector('[name="id"]')?.value;

    if (!variantId) return null;

    try {
      const productData = await fetchProductData(currentProductHandle);

      if (productData && productData.variants) {
        const variant = productData.variants.find(v => v.id.toString() === variantId.toString());
        if (variant) {
          return {
            id: variantId,
            price: variant.price * 100
          };
        }
      }
    } catch (error) {
      console.error('❌ Error fetching variant data:', error);
    }
  }

  // Function to extract product handles from mrPreCheckoutFunnels (not prices - they need to be fetched)
  function extractProductHandlesFromFunnels() {
    const productInfo = [];

    window.mrPreCheckoutFunnels.forEach(funnel => {
      if (funnel.is_enable && (funnel.funnelType === 'cvb' || funnel.funnelType === 'crossell')) {
        if (funnel.triggerType === 'cart_page' && funnel.milestones) {
          funnel.milestones.forEach(milestone => {
            if (milestone.rewards && Array.isArray(milestone.rewards)) {
              milestone.rewards.forEach(reward => {
                if (reward.rewardType === 'freegift' && reward.rewardProducts) {
                  reward.rewardProducts.forEach(product => {
                    const handle = product.title.toLowerCase().replace(/[^a-z0-9]/g, '-');
                    if (!productInfo.find(p => p.handle === handle)) {
                      productInfo.push({
                        handle: handle,
                        id: product.id.toString(),
                        title: product.title,
                        image: product.image || ''
                      });
                    }
                  });
                }
              });
            }
          });
        }

        if (funnel.triggerType === 'product_page' && funnel.offered_products) {
          funnel.offered_products.forEach(product => {
            const handle = product.title.toLowerCase().replace(/[^a-z0-9]/g, '-');
            if (!productInfo.find(p => p.handle === handle)) {
              productInfo.push({
                handle: handle,
                id: product.id.toString(),
                title: product.title,
                image: product.image || ''
              });
            }
          });
        }
      }
    });

    return productInfo;
  }

  // Function to fetch product data from Shopify API
  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.json`);
      
      if (!response.ok) {
        console.error(`❌ Product ${handle} not found (${response.status})`);
        return null;
      }

      // Check if response has content
      const text = await response.text();
      if (!text) {
        console.error(`❌ Empty response for product ${handle}`);
        return null;
      }

      const data = JSON.parse(text);

      if (data.product) {
        const product = data.product;
        return {
          handle: product.handle,
          id: product.id.toString(),
          title: product.title,
          image: product.images[0]?.src || '',
          variants: product.variants.map(variant => ({
            id: variant.id,
            price: variant.price,
            title: variant.title,
            compare_at_price: variant.compare_at_price || 0
          }))
        };
      }
    } catch (error) {
      console.error(`❌ Error fetching product ${handle}:`, error);
    }
    return null;
  }

  async function loadFreeGifts() {

    const campaignData = extractCampaignDataFromFunnels();
    const campaigns = campaignData.campaigns;
    if (!campaigns.length) {
      console.log('❌ Step 1: No campaigns found');
      return;
    }

    const { currentCartValue, totalCartValue } = await getCartAndProductValues();
    // Cache latest cart value (active currency) for rendering helper UIs
    window.latestTotalCartValue = totalCartValue;
    console.log('totalCartValue', totalCartValue);
    const matchingCampaigns = findMatchingCampaigns(campaigns, currentProductId, totalCartValue);

    if (!matchingCampaigns.length) {
      console.log('❌ Step 3: No matching campaigns found (either product rules or cart value requirements not met)');
      return;
    }
    console.log(`✅ Step 3: Found ${matchingCampaigns.length} matching campaigns`);
console.log('matchingCampaigns', matchingCampaigns);

    // Step 4: Select campaign by priority
    const selectedCampaign = selectCampaignByPriority(matchingCampaigns);
    console.log(`✅ Step 4: Selected campaign: ${selectedCampaign.name} (${selectedCampaign.type})`);

    // Step 5: Calculate max selections for selected campaign
    const maxSelections = calculateMaxSelectionsForCampaign(selectedCampaign, totalCartValue, currentCartValue);
    console.log(`✅ Step 5: Max selections: ${maxSelections}`);

    // Step 6: Extract gifts from selected campaign
    const availableGifts = await extractGiftsFromCampaign(selectedCampaign, totalCartValue);

    // Lưu thông tin campaign hiện tại
    window.currentCampaignData = {
      campaignId: selectedCampaign.id,
      campaignName: selectedCampaign.name,
      maxSelections: maxSelections,
      gifts: availableGifts.map(g => ({
        handle: g.handle,
        title: g.title
      }))
    };

    renderGifts(availableGifts, maxSelections, selectedCampaign);
  }

  async function getCartAndProductValues() {
    let currentCartValue = 0;
    let currentProductPrice = 0;

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      currentCartValue = cart.total_price;

      const currentVariant = await getCurrentVariant();

      if (currentVariant) {
        currentProductPrice = currentVariant.price;
      }
    } catch (error) {
      console.error('❌ Error fetching cart:', error);
    }

    const totalCartValue = convertToActiveCurrency(currentCartValue) + convertToActiveCurrency(currentProductPrice);

    return { currentCartValue, currentProductPrice, totalCartValue };
  }

  // Step 3: Find matching campaigns
  function findMatchingCampaigns(campaigns, currentProductId, totalCartValue) {
    return campaigns.filter(campaign => isCampaignMatched(campaign, currentProductId, totalCartValue));
  }

  // Step 4: Select campaign by priority
  function selectCampaignByPriority(matchingCampaigns) {
    // Sort by priority (smaller number = higher priority)
    matchingCampaigns.sort((a, b) => {
      const priorityA = a.priority || 999;
      const priorityB = b.priority || 999;

      return priorityA - priorityB;
    });

    return matchingCampaigns[0];
  }

  // Step 5: Calculate max selections for selected campaign
  function calculateMaxSelectionsForCampaign(campaign, totalCartValue, currentCartValue) {
    const funnelData = window.mrPreCheckoutFunnels?.find(f => f.funnel_name === campaign.name);
    if (campaign.type === 'cvb') {
      if (funnelData && funnelData.milestones) {
        const matchedMilestones = funnelData.milestones
          .filter(milestone => totalCartValue >= parseFloat(milestone.minValue))
          .sort((a, b) => parseFloat(b.minValue) - parseFloat(a.minValue));

        if (matchedMilestones.length > 0) {
          const highestMilestone = matchedMilestones[0];
          return highestMilestone.milestoneLevelFreegiftDiscountQuantity || 1;
        }
        // Not yet reached any milestone → no selection allowed
        return 0;
      }
      return 0;
    } else if (campaign.type === 'crossell') {
      return funnelData?.offerLevelDiscountQuantity || 1;
    }

    return 1;
  }

  // Step 6: Extract gifts from selected campaign
  async function extractGiftsFromCampaign(campaign, totalCartValue) {
    const gifts = [];

    if (campaign.milestones) {
      const matchedMilestones = campaign.milestones.milestones
        .filter(milestone => totalCartValue >= milestone.minimumValue)
        .sort((a, b) => b.minimumValue - a.minimumValue);
      let targetMilestone = null;
      if (matchedMilestones.length > 0) {
        targetMilestone = matchedMilestones[0];
      } else {
        // Not eligible yet → show next upcoming milestone gifts in disabled state
        targetMilestone = [...campaign.milestones.milestones].sort((a, b) => a.minimumValue - b.minimumValue)[0] || null;
      }
      if (targetMilestone) {
        for (const giftRef of targetMilestone.gifts) {
          const giftProduct = await getGiftProduct(giftRef);
          if (giftProduct) {
            gifts.push({
              handle: getGiftHandle(giftRef),
              title: giftRef.title,
              product: giftProduct
            });
          }
        }
      }
    } else if (campaign.offeredProducts) {
      for (const product of campaign.offeredProducts) {
        const giftProduct = await getGiftProduct(product);
        gifts.push({
          handle: getGiftHandle(product),
          title: product.title,
          product: giftProduct
        });
      }
    }

    return gifts;
  }

  // Compute next milestone info for CVB campaigns
  function getNextMilestoneInfo(campaign, totalCartValue) {
    if (!campaign || !campaign.milestones || !campaign.milestones.milestones) return null;
    const sorted = [...campaign.milestones.milestones].sort((a, b) => a.minimumValue - b.minimumValue);
    const next = sorted.find(m => totalCartValue < m.minimumValue);
    if (!next) return null;
    const remaining = Math.max(0, next.minimumValue - totalCartValue);
    // remaining is in active currency units -> convert to cents for formatMoney
    const remainingCents = Math.round(remaining * 100);
    return { remainingCents, targetValue: next.minimumValue };
  }


  function renderUnlockNote(selectedCampaign) {
    const freeGiftsContainer = document.querySelector('.free-gifts');
    if (!freeGiftsContainer) return;

    let note = freeGiftsContainer.querySelector('.gift-unlock-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'gift-unlock-note';
      note.style.marginTop = '12px';
      freeGiftsContainer.appendChild(note);
    }

    const maxSel = window.maxSelections || 0;
    const totalCartValue = window.latestTotalCartValue || 0;
    const info = getNextMilestoneInfo(selectedCampaign, totalCartValue);

    if (maxSel === 0) {
      // No gifts unlocked yet - show unlock message
      if (info) {
        note.innerHTML = `Add ${formatMoney(info.remainingCents, window.theme?.moneyFormat)} more to unlock gifts`;
        note.style.display = '';
      } else {
        note.style.display = 'none';
      }
    } else {
      // Gifts are unlocked - show selection message
      const giftText = maxSel === 1 ? 'gift' : 'gifts';
      
      if (info) {
        // Can unlock more gifts
        note.innerHTML = `You can pick ${maxSel} ${giftText}, add ${formatMoney(info.remainingCents, window.theme?.moneyFormat)} more to unlock more gifts`;
      } else {
        // Already at highest tier
        note.innerHTML = `You can pick ${maxSel} ${giftText}`;
      }
      note.style.display = '';
    }
  }

  // Helper: Get product handle from gift reference
  function getGiftHandle(giftRef) {
    return giftRef.productHandle || giftRef.handle || '';
  }

  // Helper: Get gift product data - Always fetch from Shopify API to get correct currency prices
  async function getGiftProduct(giftRef) {
    const handle = getGiftHandle(giftRef);
    const productData = await fetchProductData(handle);
    if (productData) {
      return productData;
    }

    if (giftRef.productData) {
      console.warn('⚠️ Using fallback prices from mrPreCheckoutFunnels - may not match customer currency');
      return {
        handle: handle,
        id: giftRef.productData.id?.toString() || '',
        title: giftRef.productData.title || giftRef.title,
        image: giftRef.productData.image || '',
        variants: giftRef.productData.variants?.map(variant => ({
          id: variant.id,
          price: variant.price,
          title: variant.title || '',
          compare_at_price: variant.compareAtPrice || 0
        })) || []
      };
    }
    return {
      handle: handle,
      id: giftRef.id?.toString() || '',
      title: giftRef.title || '',
      image: giftRef.image || giftRef.productData?.image || '',
      variants: giftRef.variants?.map(variant => ({
        id: variant.id,
        price: convertFreeGiftCurrency(variant.price),
        title: variant.title || '',
        compare_at_price: variant.compareAtPrice || 0
      })) || []
    };

  }

  function isCampaignMatched(campaign, currentProductId, totalCartValue) {
    const funnelData = window.mrPreCheckoutFunnels?.find(f => f.funnel_name === campaign.name);
    if (!funnelData || !funnelData.groups || funnelData.groups.length === 0) {
      console.log(`   ❌ No funnel data or groups found`);
      return false;
    }

    for (const group of funnelData.groups) {
      if (!group.rules || group.rules.length === 0) {
        continue;
      }
      for (const rule of group.rules) {
        if (rule.ruleType !== "product") {
          continue;
        }
        const ruleProducts = rule.ruleProducts || [];
        if (rule.operator === "contains_any") {
          const isMatch = ruleProducts.some(ruleProduct =>
            ruleProduct.sp_product_id.toString() === currentProductId?.toString()
          );
          if (isMatch) {
            return true;
          }
        } else if (rule.operator === "equals_anything") {
          return true;
        }
      }
    }
    return false;
  }

  // Step 7: Render gifts
  function renderGifts(availableGifts, maxSelections, selectedCampaign) {
    const freeGiftsContainer = document.querySelector('.free-gifts');
    const giftsContainer = document.querySelector('.gifts-container');

    if (!freeGiftsContainer || !giftsContainer) {
      return;
    }

    // Clear existing gifts and reset any previous selections
    giftsContainer.innerHTML = '';
    selectedGifts = new Map();

    // Remove duplicates
    const uniqueGifts = [];
    const seenHandles = new Set();
    availableGifts.forEach(gift => {
      if (!seenHandles.has(gift.handle)) {
        seenHandles.add(gift.handle);
        uniqueGifts.push(gift);
      }
    });

    // Render gift items
    uniqueGifts.forEach((gift, index) => {
      const normalizedProduct = gift.product || gift;

      if (!normalizedProduct.variants || normalizedProduct.variants.length === 0) {
        return;
      }

      const variant = normalizedProduct.variants[0];
      if (!variant) {
        return;
      }

      const giftItem = createGiftItemFromAvadaData(normalizedProduct, variant);
      if (!giftItem) {
        return;
      }

      if (maxSelections === 0) {
        giftItem.classList.add('disabled');
        giftItem.title = 'Cart value not sufficient for free gifts';
      }

      giftsContainer.appendChild(giftItem);
    });

    // Show container and setup interactions
    freeGiftsContainer.style.display = 'block';
    window.maxSelections = maxSelections;
    setupGiftSelection();
    enforceSelectionLimit();
    renderUnlockNote(selectedCampaign);
    setupVariantChangeListener();
  }


  loadFreeGifts();

  // Setup variant change listener to update gifts when variant changes
  function setupVariantChangeListener() {
    // Helper to observe a node's text/attribute mutations and trigger recalculation
    const observeNode = (node, key) => {
      if (!node) return;
      const storageKey = `__observer_${key}`;
      if (node[storageKey]) return; // already observing
      let lastText = node.textContent ? node.textContent.trim() : '';
      const obs = new MutationObserver(() => {
        const now = node.textContent ? node.textContent.trim() : '';
        if (now !== lastText) {
          lastText = now;
          handleVariantChange();
        }
      });
      obs.observe(node, { childList: true, characterData: true, subtree: true, attributes: true });
      node[storageKey] = obs;
    };

    // Observe subtotal (used on our step footer)
    observeNode(document.querySelector('.step-footer-wrapper .subtotal .money'), 'subtotal');
    // Observe product price element when subtotal isn't available or doesn't change
    observeNode(document.querySelector('.step-footer-wrapper .money[data-variant-id]'), 'variantMoney');
    // Fallback: common product price containers
    observeNode(document.querySelector('.product__price, .price, [data-product-price]'), 'productPrice');
  }

  async function handleVariantChange() {
    const campaignData = extractCampaignDataFromFunnels();
    const campaigns = campaignData.campaigns;

    if (!campaigns.length) {
      const giftsContainer = document.querySelector('.gifts-container');
      if (giftsContainer) {
        giftsContainer.innerHTML = '';
      }
      return;
    }

    const { currentCartValue, currentProductPrice, totalCartValue } = await getCartAndProductValues();
    window.latestTotalCartValue = totalCartValue;

    const matchingCampaigns = findMatchingCampaigns(campaigns, currentProductId, totalCartValue);

    if (!matchingCampaigns.length) {
      const giftsContainer = document.querySelector('.gifts-container');
      if (giftsContainer) {
        giftsContainer.innerHTML = '';
      }
      return;
    }

    const selectedCampaign = selectCampaignByPriority(matchingCampaigns);
    const maxSelections = calculateMaxSelectionsForCampaign(selectedCampaign, totalCartValue, currentCartValue);
    const availableGifts = await extractGiftsFromCampaign(selectedCampaign, totalCartValue);

    const newCampaignData = {
      campaignId: selectedCampaign.id,
      campaignName: selectedCampaign.name,
      maxSelections: maxSelections,
      gifts: availableGifts.map(g => ({
        handle: g.handle,
        title: g.title
      }))
    };

    // Always re-render because price/eligibility can change even if campaign and gifts stay the same

    const giftsContainer = document.querySelector('.gifts-container');
    if (giftsContainer) {
      giftsContainer.innerHTML = '';
    }
    window.currentCampaignData = newCampaignData;
    renderGifts(availableGifts, maxSelections, selectedCampaign);
  }

  function createGiftItemFromAvadaData(giftProduct, variant) {

    const giftItem = document.createElement('div');
    giftItem.className = 'gift-item';
    giftItem.setAttribute('data-product-handle', giftProduct.handle);
    giftItem.setAttribute('data-variant-id', variant.id);
    const priceInCents = parseFloat(variant.price) * 100;

    const formattedPrice = formatMoney(priceInCents, window.theme?.moneyFormat);

    giftItem.innerHTML = `
      <div class="gift-card-inner">
        <div class="gift-thumb">
          <img src="${giftProduct.image || ''}" 
               alt="${giftProduct.title}"
               loading="lazy"
               onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjI0MCIgdmlld0JveD0iMCAwIDI0MCAyNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyNDAiIGhlaWdodD0iMjQwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjEyMCIgeT0iMTIwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTk5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5Qcm9kdWN0IEltYWdlPC90ZXh0Pgo8L3N2Zz4K'">
        </div>
        
        <div class="gift-meta">
          <div class="gift-header">
            <span class="gift-badge">Free</span>
            <div class="gift-title">${giftProduct.title}</div>
          </div>
          <div class="gift-compare">${formattedPrice}</div>
          
        </div>
      </div>
    `;
    return giftItem;
  }

  // Global variable to store selected gifts
  let selectedGifts = new Map();

  // Setup gift selection handlers
  function setupGiftSelection() {
    const giftItems = document.querySelectorAll('.gift-item');
    console.log('🔍 Found gift items:', giftItems.length);
    const maxSelections = (typeof window.maxSelections === 'number') ? window.maxSelections : 1;

    giftItems.forEach(item => {
      item.addEventListener('click', function () {
        console.log('🎁 Gift item clicked:', this.dataset.productHandle);
        // Don't allow selection if maxSelections is 0
        if (maxSelections === 0) {
          return;
        }

        const productHandle = this.dataset.productHandle;
        const isSelected = this.classList.contains('selected');

        if (isSelected) {
          // Deselect current gift
          this.classList.remove('selected');
          selectedGifts.delete(productHandle);
        } else {
          // Check if we can select more gifts
          if (selectedGifts.size >= maxSelections) {
            return; // Prevent selecting more than max
          }

          // Select new gift
          this.classList.add('selected');
          selectedGifts.set(productHandle, {
            variantId: this.dataset.variantId,
            title: this.querySelector('.gift-title').textContent
          });
        }

        updateMainAddToCartButton();
        enforceSelectionLimit();
      });
    });
  }

  // Disable remaining gift items when selection limit is reached
  function enforceSelectionLimit() {
    const giftItems = document.querySelectorAll('.gift-item');
    const maxSelections = (typeof window.maxSelections === 'number') ? window.maxSelections : 1;
    const reachedLimit = selectedGifts.size >= maxSelections;
    giftItems.forEach(item => {
      const isSelected = item.classList.contains('selected');
      if ((maxSelections === 0) || (reachedLimit && !isSelected)) {
        item.classList.add('disabled');
        item.setAttribute('aria-disabled', 'true');
      } else {
        item.classList.remove('disabled');
        item.removeAttribute('aria-disabled');
      }
    });
  }

  // Update main add to cart button to include selected gifts
  function updateMainAddToCartButton() {
    const mainAddToCartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"], .product-form__cart-submit, .btn--add-to-cart');

    if (mainAddToCartBtn && selectedGifts.size > 0) {
      const giftDataArray = Array.from(selectedGifts.values()).map(gift => ({
        variantId: gift.variantId,
        title: gift.title
      }));

      mainAddToCartBtn.dataset.selectedGifts = JSON.stringify(giftDataArray);
      console.log('✅ Set selectedGifts dataset:', mainAddToCartBtn.dataset.selectedGifts);

      if (!mainAddToCartBtn.querySelector('.gift-indicator')) {
        const indicator = document.createElement('span');
        indicator.className = 'gift-indicator';
        indicator.innerHTML = ` 🎁 (${selectedGifts.size})`;
        mainAddToCartBtn.appendChild(indicator);
      }
    } else if (mainAddToCartBtn) {
      delete mainAddToCartBtn.dataset.selectedGifts;
      const indicator = mainAddToCartBtn.querySelector('.gift-indicator');
      if (indicator) {
        indicator.remove();
      }
      console.log('❌ No gifts selected, removed dataset');
    }
  }

  // Intercept main add to cart button click
  function interceptAddToCart() {
    console.log('🔧 interceptAddToCart() called');

    if (window.addToCartIntercepted) {
      console.log('⚠️ Already intercepted, skipping');
      return;
    }
    window.addToCartIntercepted = true;
    const selectors = [
      '.atc-btn.klaviyo-atc-track',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__cart-submit',
      '.btn--add-to-cart',
      'button[type="submit"]',
      'form button[type="submit"]',
      '.product-form button',
      '[data-add-to-cart]'
    ];

    let mainAddToCartBtn = null;
    for (const selector of selectors) {
      const btn = document.querySelector(selector);
      if (btn && !mainAddToCartBtn) {
        mainAddToCartBtn = btn;
        break;
      }
    }

    if (mainAddToCartBtn) {
      const originalSubmitHandler = mainAddToCartBtn.onclick;

      mainAddToCartBtn.addEventListener('click', async function (e) {
        console.log('selectedGifts',selectedGifts);
        
        if (selectedGifts.size > 0 && window.maxSelections > 0) {
          setTimeout(async () => {
            try {
              const gifts = Array.from(selectedGifts.values());
              await new Promise(resolve => setTimeout(resolve, 50));
              console.log('gifts',gifts);
              
              const giftItems = gifts
                .filter(gift => gift.variantId)
                .map(gift => ({
                  id: gift.variantId,
                  quantity: 1,
                  properties: {
                    '_Free Gift': true
                  }
                }));
              console.log('giftItems',giftItems);
              
              if (giftItems.length > 0) {
                console.log(`🎁 Adding ${giftItems.length} free gift(s)`);

                try {
                  const giftResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      items: giftItems
                    })
                  });

                  if (!giftResponse.ok) {
                    const errorText = await giftResponse.text();
                    console.error(`❌ Failed to add gifts:`, errorText);
                  } else {
                    const result = await giftResponse.json();
                    console.log(`✅ Successfully added ${giftItems.length} gift(s):`, result);
                  }
                } catch (giftError) {
                  console.error(`❌ Error adding gifts:`, giftError);
                }
              }

              console.log('✅ Finished adding all free gifts');

              try {
                console.log('🔄 Updating cart...');
                if (typeof reBuildCart === 'function') {
                  reBuildCart();
                  console.log('✅ Cart UI updated successfully');
                  
                  // Open cart drawer to show the added gifts
                  if (typeof open_cart_drawer === 'function') {
                    open_cart_drawer();
                    console.log('✅ Cart drawer opened');
                  }
                } else {
                  console.warn('⚠️ reBuildCart function not found, cart may not update visually');
                }
              } catch (updateError) {
                console.error('❌ Error updating cart:', updateError);
              }

            } catch (error) {
              console.error('❌ Error adding free gifts to cart:', error);
            }
          }, 100);
        } else {
          console.log('ℹ️ No free gifts selected or max selections is 0');
        }
      });
    } else {
      console.log('❌ Could not find main add to cart button');
    }
  }

  await waitForMrPreCheckoutFunnels();
  loadFreeGifts();

  interceptAddToCart();

  // Prevent multiple observers and interceptors
  if (!window.giftObserverAdded) {
    window.giftObserverAdded = true;

    setTimeout(() => {
      console.log('⏰ Calling interceptAddToCart() after 1000ms delay');
      interceptAddToCart();
    }, 1000);

    const observer = new MutationObserver(() => {
      const btn = document.querySelector('button[type="submit"], .product-form__cart-submit, .btn--add-to-cart');
      if (btn && !btn.dataset.giftListenerAdded) {
        btn.dataset.giftListenerAdded = 'true';
        console.log('👁️ MutationObserver detected new button, calling interceptAddToCart()');
        interceptAddToCart();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});